export enum STORAGE_KEYS {
  USER = 'asc-u',
  ACCESS_TOKEN = 'asc-atkn',
  REFRESH_TOKEN = 'asc-rtkn',
  REMEMBER_ME = 'asc-rmbrme',
  EXPIRES_AT = 'asc-exp',
  USER_ROLE = 'asc-ur',
  TIME_SPENT = 'asc-tc',
  SESSION_KEY = 'asc-ssnk',
  MODULE_ATTEMPTED = 'asc-modatt',
  ADM_ACCESS_TOKEN = 'asc-adm-atkn',
  ADM_REFRESH_TOKEN = 'asc-adm-rtkn',
  ADM_REMEMBER_ME = 'asc-adm-rmbrme',
  ADM_USER_ROLE = 'asc-adm-ur',
  VERIFY_PROCESS = 'verifyProcess',
  VERIFY_ID = 'verifyId',
  SIGN_IN_PROCESS = 'signInProcess',
  ACTIVE_PILLAR_LIST = 'asc-ac-p-l',
  CLEVER_CONNECTION_STATUS = 'asc-cl-c-st',
  CLEVER_JOB_ID = 'asc-cl-j-id',
  SHIBBOLETH_CONNECTION_STATUS = 'asc-sh-c-st'
}
